export enum ClassEnergetiqueEnum {
  CLASSE_ENERGETIQUE_INCONNUE = 'CLASSE_ENERGETIQUE_INCONNUE',
  CLASSE_ENERGETIQUE_B = 'CLASSE_ENERGETIQUE_B',
  CLASSE_ENERGETIQUE_A = 'CLASSE_ENERGETIQUE_A',
  CLASSE_ENERGETIQUE_A_PLUS = 'CLASSE_ENERGETIQUE_A_PLUS',
  CLASSE_ENERGETIQUE_A_PLUS_PLUS = 'CLASSE_ENERGETIQUE_A_PLUS_PLUS',
  CLASSE_ENERGETIQUE_A_PLUS_PLUS_PLUS = 'CLASSE_ENERGETIQUE_A_PLUS_PLUS_PLUS',
}
